const ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_KEY = "adobeopt_exp";
const ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_VALUE = "grs";
const GRS_PROVIDER_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY = "grs_provider_feature_toggle";
const GRS_PROVIDER_BETA_RELEASE_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY = "grs_beta_release_enabled";
const GRS_SEARCH_PROVIDER_SESSION_STORAGE_VALUE = "grs";
const SEARCH_PROVIDER_SESSION_STORAGE_KEY = "searchProvider";
const SEARCH_SERVICE_PROVIDERS = {
  LUCIDWORKS: "lucidworks",
  GRS: "grs"
};
export {
  ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_KEY,
  ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_VALUE,
  GRS_PROVIDER_BETA_RELEASE_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY,
  GRS_PROVIDER_FEATURE_TOGGLE_CONFIG_DEVELOPMENT_KEY,
  GRS_SEARCH_PROVIDER_SESSION_STORAGE_VALUE,
  SEARCH_PROVIDER_SESSION_STORAGE_KEY,
  SEARCH_SERVICE_PROVIDERS
};
